import { useFormsTemplate } from '@commenda/api';
import { Loading } from '@commenda/kakashi';
import { FormBuilderEditorShell } from '@commenda/ui/form-builder';
import { FormEditorProvider } from '@commenda/ui/form-builder/hooks/useFormEditor';
import { useRouter } from 'next/router';
import { AffiliateFormHelper } from './affiliate-form-helper';

/** Mounts the v1 builder on the affiliate app: firm-scoped routes, no key management, no dev
 * mode, and read-only whenever the open form is one of Commenda's shared templates. */
export const AffiliateFormEditor = () => {
  const router = useRouter();
  const firmId = typeof router.query.id === 'string' ? router.query.id : '';
  const templateId =
    typeof router.query.templateId === 'string'
      ? router.query.templateId
      : undefined;
  const returnHref = AffiliateFormHelper.sanitizeReturnHref(
    typeof router.query.from === 'string' ? router.query.from : undefined,
    firmId
  );

  // SWR dedupes this against the provider's own fetch of the same template, so opening the
  // editor is still one request.
  const { template, isLoading } = useFormsTemplate(templateId);

  if (!firmId) return null;

  if (templateId && isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-bg-tertiary">
        <Loading />
      </div>
    );
  }

  const listHref = AffiliateFormHelper.getFormsListHref(firmId);

  return (
    <FormEditorProvider
      editorPath={AffiliateFormHelper.getFormEditorPath(firmId)}
      templatesPath={listHref}
      previewPath={AffiliateFormHelper.getFormPreviewPath(firmId)}
      readOnly={
        template ? AffiliateFormHelper.isSharedTemplate(template) : false
      }
      storageKey={AffiliateFormHelper.getDraftStorageKey(firmId)}
      defaultDevMode={false}
      showKeyManagement={false}
      getVersionsHref={() => returnHref ?? listHref}
      getPreviewHref={(id) =>
        `${AffiliateFormHelper.getFormPreviewPath(firmId)}?templateId=${id}`
      }
    >
      <FormBuilderEditorShell />
    </FormEditorProvider>
  );
};
